/*------------------------------------------------------------------
External
------------------------------------------------------------------*/

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/*------------------------------------------------------------------
Templates
------------------------------------------------------------------*/

/**
 * 
 * SWAL Booking title
 * 
 * @returns {string} html template
 */
export const swalSearchAgentTitle = () => {
    return /*html*/`
    Please enter your <br>agent or branch code`;
};


/**
 * 
 * SWAL booking number template
 * 
 * @returns {string} html template
 */
export const swalSearchAgentDetails = () => {
    return/*html*/`
    <input id="swal-input1" class="[ js-agent-code ]" required="required" placeholder="Enter your agent code" value=""><br><br>`;
};


/**
 * 
 * SWAL Booking title
 * 
 * @returns {string} html template
 */
export const swalEnterBookingTitle = () => {
    return /*html*/`
    Please enter your <br>Spaceships booking number`;
};


/**
 * 
 * SWAL booking number template
 * 
 * @returns {string} html template
 */
export const swalEnterBookingDetails = () => {
    return/*html*/`
    <p>It's the 5 or 6 digit number that starts with #, for example: #12345</p>
    <input id="swal-input1" class="[ js-reservation-number ]" required="required" placeholder="Booking number e.g. 12345" value=""><br><br>
    <input id="swal-input2" class="[ js-last-name ]" required="required" placeholder="Last Name" value="">`;
};


/**
 * 
 * Failed SWAL title
 * 
 * @returns {string} html template
 */
export const swalEnterBookingTitleFail = () => {
    return /*html*/`
    Whoops!`;
};


/**
 * 
 * Failed SWAL modal
 * 
 * @returns {string} html template
 */
export const swalEnterBookingDetailsFail = () => {
    return/*html*/`
    <input id="swal-input1" class="[ js-reservation-number ]" required="required" placeholder="Booking number e.g. 12345" value=""><br><br>
    <input id="swal-input2" class="[ js-last-name ]" required="required" placeholder="Last Name" value="">`;
};


/**
 * 
 * Tooltip tempalting
 * 
 * @param {String} copy 
 * @returns {string} html template
 */
export const tooltip = (copy) => {
    return /*html*/`
    <span class="tooltip">
        <span class="tooltip__wrap">
            ${copy}
        </span>
    </span>`;
};


/**
 * 
 * Payment page vehicle thumbnail 
 * 
 * @param {object} results 
 * @returns {string} html template
 */
export const paymentThumbnail = (id) => {

    var urlParams = new URLSearchParams(window.location.search);
    var country = urlParams.get('country');
    let image = window.images.filter(image => image.vehicle_id == id)[0];
    if (country) {
        image = window.images.filter(image => image.vehicle_id == id && image.country === country)[0];
    }
    return /*html*/`
    <img src="${(image) ? image.thumbnail_url : ''}" width="640" height="360" loading="lazy" alt="placeholder image"></img>`;
};


/**
 * 
 * Payment page dates section with the dates and times
 * 
 * @param {object} results 
 * @returns {string} html template
 */
export const paymentDates = (results) => {

    // Simplified booking info
    let booking_info = results.bookinginfo[0];

    // Get the booking dropoff date and make sure that it is less than 28 days 
    // let booking_less_than_28_days = new dayjs(booking_info.dropoffdate, 'DD/MMM/YYYY').diff(new dayjs(), 'day') > 28;

    // Get the booking pickup date and make sure that it is more than two days away
    let booking_is_more_than_two_days_away = new dayjs(booking_info.pickupdate, 'DD/MMM/YYYY').diff(new dayjs(), 'day') > 2;

    // Get the booking pickup date and make sure that it is more than one day away
    let booking_is_more_than_one_day_away = new dayjs(booking_info.pickupdate, 'DD/MMM/YYYY').diff(new dayjs(), 'day') > 1;

    return /*html */`
    <div class="cards__item__list__item">
        <span class="icon icon--tickets"><b></b></span> Booking Number: <b>${booking_info.reservationdocumentno}</b>
    </div>
    <div class="cards__item__list__item">
        <span class="icon icon--poi"><b></b></span> Pickup Location: <b>${booking_info.pickuplocationname}</b>
    </div>
    <div class="cards__item__list__item">
        <span class="icon icon--calendar"><b></b></span> Pickup Date: <b>${dayjs(booking_info.pickupdate, 'DD/MMM/YYYY').format('D MMMM YYYY')}, ${dayjs('1/1/1 ' + booking_info.pickuptime).format('HH:mm')}</b>
    </div >
    <div class="cards__item__list__item">
        <span class="icon icon--poi"><b></b></span> Return Location: <b>${booking_info.dropofflocationname}</b>
    </div>
    <div class="cards__item__list__item">
        <span class="icon icon--calendar"><b></b></span> Return Time: <b>${dayjs(booking_info.dropoffdate, 'DD/MMM/YYYY').format('D MMMM YYYY')}, ${dayjs('1/1/1 ' + booking_info.dropofftime).format('HH:mm')}</b>
    </div>
    ${(window.currency_name === 'NZD' && window.pageType === 'checkin-portal') ? /*html */`
        <div class="cards__item__list__item">
            <button class="button button--full-width [ js-open-booking-times-modal ] ${(booking_is_more_than_two_days_away) ? `` : `inactive`}">Update Pick-Up or Drop-Off Times<span class="buttonLoader"></span></button>
        </div>`: ``} 
    ${(window.currency_name === 'AUD' && window.pageType === 'checkin-portal') ? /*html */`
        <div class="cards__item__list__item">
            <button class="button button--full-width [ js-open-booking-times-modal ] ${(booking_is_more_than_one_day_away) ? `` : `inactive`}">Update Pick-Up or Drop-Off Times<span class="buttonLoader"></span></button>
        </div>`: ``}
    `;
};


/**
 * 
 * Payment page extra fee items
 *
 * @param {object} item
 * @returns {string} html template
 */
export const extraFee = (item) => {
    // we want to hide the pricing on certain page types
    if (window.pageType === 'checkin-portal' || window.pageType === 'payment') {
        if (item.isinsurancefee) {
            return /* html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${item.name}<br>
            ${item.numberofdays} days 
        </div>`;
        } else {
            return /* html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${item.name} ${(item.qty && item.qty > 1) ? `x ${item.qty}` : ''}
            ${(item.totalfeeamount === 0 && item.id !== 387) ? '<b class="colour--green">FREE</b>' : ''}
        </div>`;
        }
    } else {
        if (item.isinsurancefee) {
            return /* html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${item.name}<br>
            ${item.numberofdays} days @ ${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${item.fees} per day
            <b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${parseFloat(item.totalfeeamount).toFixed(2)}</b>
        </div>`;
        } else {
            return /* html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${item.name} ${(item.qty && item.qty > 1) ? `x ${item.qty}` : ''}
            ${(item.totalfeeamount === 0 && item.id !== 387) ? '<b class="colour--green">FREE</b>' : `<b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${item.totalfeeamount}</b>`}
        </div>`;
        }
    }
};


/**
 * 
 * Payment page line item details
 * 
 * @param {object} results 
 * @returns {string} html template
 */
export const paymentDetails = (results, isAgentBooking = false) => {

    // Simplified booking info
    let booking = results.bookinginfo[0];
    let rateinfo = results.rateinfo[0];

    if (window.pageType === 'checkin-portal' || window.pageType === 'payment') {
        return /*html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${booking.numberofdays} days booked
        </div>
    
        ${results.extrafees.map(item => extraFee(item)).join('')}
        
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--large cards__item__list__item--remaining" ${isAgentBooking ? `style="display:none;"` : ``}>
            Remaining Amount
            <b class="colour--red">${booking.currencysymbol}${parseFloat(booking.balancedue).toFixed(2)}</b>
        </div>
    
        ${(isAgentBooking) ? /*html*/`
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--agent-comission">
            Agent Commission
            <span class="eye [ js-toggle-sensitive-data ]"></span>
            <b class="colour--green">${booking.currencysymbol}${parseFloat(booking.agentcommission).toFixed(2)}</b>
        </div>`: ``}`;
    } else {

        return /*html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${booking.numberofdays} days @ ${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${booking.dailyrate} per day
            <b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${parseFloat(rateinfo.ratesubtotal).toFixed(2)}</b>
        </div>
    
        ${(rateinfo.discountpercentagerate !== 0) ?/*html*/`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${rateinfo.dailyratebeforediscount} per day less ${rateinfo.discountpercentagerate}% discount
        </div>`: ``}
    
        ${results.extrafees.map(item => extraFee(item)).join('')}
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--large cards__item__list__item--total">
            Total
            <b>${booking.currencyname} ${booking.currencysymbol}${parseFloat(booking.totalcost).toFixed(2)}</b>
        </div>
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--large cards__item__list__item--paid" ${isAgentBooking ? `style="display:none;"` : ``}>
            Amount Paid
            <b class="colour--green">${booking.currencysymbol}${parseFloat(booking.totalcost - booking.balancedue).toFixed(2)}</b>
        </div>
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--large cards__item__list__item--remaining" ${isAgentBooking ? `style="display:none;"` : ``}>
            Remaining Amount
            <b class="colour--red">${booking.currencysymbol}${parseFloat(booking.balancedue).toFixed(2)}</b>
        </div>
    
        ${(isAgentBooking) ? /*html*/`
        <div class="cards__item__list__item cards__item__list__item--cost cards__item__list__item--agent-comission">
            Agent Commission
            <span class="eye [ js-toggle-sensitive-data ]"></span>
            <b class="colour--green">${booking.currencysymbol}${parseFloat(booking.agentcommission).toFixed(2)}</b>
        </div>`: ``}`;
    }

};


/**
 * 
 * Insurance item template for the booking page
 * 
 * @param {object} insurance 
 * @param {number} index 
 * @returns {string} html template
 */
export const insuranceItem = (insurance, index, mostPopular = undefined) => {

    let insuranceCostPerDay = parseFloat(insurance.fees);
    if (insurance.maximumprice === insurance.totalinsuranceamount) insuranceCostPerDay = parseFloat(insurance.totalinsuranceamount / insurance.numberofdays);
    insuranceCostPerDay = Math.round(insuranceCostPerDay);


    // Determine if the insurance item is recommended
    let recommended = (mostPopular === insurance.id || (!mostPopular && index === 0)) ? 'recommended-for-you' : '';

    return /*html*/`
    <div class="cards__item__insurances__item ${(index === 0 && window.pageType !== 'checkin-portal') ? `selected` : ``} ${recommended}" data-id="${insurance.id}">
        <div class="cards__item__insurances__item__copy">
            <h6 class="cards__item__insurances__item__copy__title">
                ${insurance.name}
            </h6>
            <div class="cards__item__insurances__item__copy__features">
                ${(insurance.feedescription1) ? `<div class="cards__item__insurances__item__copy__features__item">${insurance.feedescription1}</div>` : ``}
                ${(insurance.feedescription2) ? `<div class="cards__item__insurances__item__copy__features__item">${insurance.feedescription2}</div>` : ``}
                ${(insurance.feedescription3) ? `<div class="cards__item__insurances__item__copy__features__item">${insurance.feedescription3}</div>` : ``}
            </div>
            <div class="cards__item__insurances__item__copy__toggle [ js-toggle-features ]">
                View all features <svg viewBox="0 0 100 100"><path d="M90 50 40 0 30 10l40 40-40 40 10 10Z" fill="#333" class="arrow"/></svg>
            </div>
        </div>
        <div class="cards__item__insurances__item__actions">
            <div class="cards__item__insurances__item__actions__price"><b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${insuranceCostPerDay}</b><span>PER DAY</span></div>
            <div class="cards__item__insurances__item__actions__add"><button data-id="${insurance.id}" class="[ js-select-insurance ] button button--small">Select</button></div>
        </div>
    </div>`;
};

export const stripTags = (input) => {
    return input.replace(/<\/?[^>]+(>|$)/g, "");
}

export const formatInsuranceText = (text) => {
    return text
        // Add <br> before "Insurance" (only if it's not already preceded by a <br>)
        .replace(/\b(Insurance)\b/g, '<br>$1')
        // Wrap everything in parentheses (...) with a span
        .replace(/\(([^)]+)\)/g, '<span>($1)</span>');
}


export const insuranceRiskMeter = (risk_level) => {
    let risk_message = '';

    switch (risk_level.toLowerCase()) {
        case 'low':
            risk_message = '<b>Stress-Free</b> - Our most comprehensive option, perfect for drivers who want to avoid unexpected costs and enjoy complete peace of mind during their rental.';
            break;
        case 'medium':
            risk_message = '<b>Partial</b> - Reduces your excess, but offers no extra coverage. Suitable for drivers who want some protection but are still comfortable accepting risk for common types of damage.';
            break;
        case 'high':
            risk_message = '<b>Basic</b> - Riskiest option for confident drivers who want the lowest upfront cost and are prepared to accept full financial responsibility for most types of damage.';
            break;
    }


    return /*html*/`
    <div class="insurances__risk" data-level="${risk_level.toLowerCase()}">
        <p><b>Risk meter<span class="insurances__risk__info">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0a8.002 8.002 0 0 1 8 8 8.002 8.002 0 0 1-8 8 8.002 8.002 0 0 1-8-8 8.002 8.002 0 0 1 8-8Zm0 2a5.996 5.996 0 0 0-4.242 1.758 5.996 5.996 0 0 0 0 8.484 5.997 5.997 0 0 0 8.484 0 5.996 5.996 0 0 0 0-8.484A5.996 5.996 0 0 0 8 2Zm1 5.5V12H7V7.5h2ZM9 5c0 1.333-2 1.333-2 0s2-1.333 2 0Z" fill="#40A5D0" fill-rule="evenodd"></path></svg>
            <span class="tooltip">
                <span class="tooltip__wrap">
                    ${risk_message}
                </span>
            </span>
        </span>:</b></p>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200">
            <path style="fill:#333" class="needle" d="m157.25 140.58-5.28-37.26c-.37-2.23-3.57-2.23-3.95 0l-5.28 37.27c-.15.89-.55 1.72-1.13 2.42-1.92 2.3-2.92 5.39-2.41 8.72.74 4.8 4.73 8.61 9.56 9.14 6.59.72 12.17-4.42 12.17-10.86 0-2.65-.95-5.08-2.52-6.97-.59-.71-1.01-1.54-1.16-2.45Z" />
            <path style="fill: #5CB85B" d="M108.58 88.25 85.05 47.5a3.005 3.005 0 0 0-4.28-.99c-32.53 21.8-54.21 58.53-55.23 100.38-.04 1.69 1.31 3.1 3 3.1h47.11c0-25.73 13.07-48.4 32.93-61.75Z"  />
            <path style="fill:#fad220" d="m182.76 83.25 23.53-40.76c.87-1.51.27-3.43-1.29-4.21-16.59-8.18-35.26-12.79-55-12.79s-38.41 4.6-55 12.79a3.003 3.003 0 0 0-1.29 4.21l23.53 40.76c9.89-4.86 21-7.6 32.76-7.6s22.88 2.74 32.76 7.6"  />
            <path style="fill: #DF542F" d="M219.23 46.52a3.003 3.003 0 0 0-4.28.99l-23.53 40.75c19.86 13.35 32.93 36.02 32.93 61.75h47.11c1.7 0 3.04-1.4 3-3.1-1.02-41.85-22.7-78.58-55.23-100.38Z"  />
            <path style="fill:#459D44" d="M88.29 147.14c.86-18.96 10.28-35.68 24.48-46.42 1.2-.91 1.52-2.57.77-3.87l-4.96-8.59c-19.86 13.35-32.93 36.02-32.93 61.75h9.65c1.6 0 2.92-1.26 2.99-2.86Z"  />
            <path style="fill:#eda900" d="M125.94 93.09c7.39-3.13 15.52-4.87 24.06-4.87s16.66 1.74 24.06 4.87c1.39.59 3 .05 3.75-1.26l4.95-8.58c-9.89-4.86-21-7.6-32.76-7.6s-22.88 2.74-32.76 7.6l4.95 8.58a2.98 2.98 0 0 0 3.75 1.26"  />
            <path style="fill:#b54425" d="m191.42 88.25-4.96 8.59c-.75 1.3-.43 2.96.77 3.87 14.2 10.74 23.61 27.46 24.48 46.42.07 1.6 1.39 2.86 2.99 2.86h9.65c0-25.73-13.07-48.4-32.93-61.75Z"  />
            <path style="fill: #5CB85B" d="M45.66 168.58h2.69v1.58h-4.74v-8.42h2.05zM51.13 169.69c-.66-.37-1.18-.88-1.57-1.54s-.58-1.4-.58-2.23.19-1.56.58-2.22.91-1.17 1.57-1.54 1.39-.55 2.18-.55 1.52.18 2.18.55 1.18.88 1.56 1.54.57 1.4.57 2.22-.19 1.57-.58 2.23c-.38.66-.9 1.17-1.56 1.54s-1.38.55-2.17.55-1.52-.18-2.18-.55m3.8-1.99c.4-.45.61-1.04.61-1.78s-.2-1.34-.61-1.78c-.4-.44-.94-.67-1.61-.67s-1.22.22-1.63.66c-.4.44-.61 1.04-.61 1.79s.2 1.34.61 1.78c.4.44.95.67 1.63.67s1.21-.22 1.61-.67M70.35 161.74l-2.2 8.42h-2.48l-1.34-5.54-1.39 5.54h-2.48l-2.14-8.42h2.2l1.21 6.13 1.5-6.13h2.26l1.44 6.13 1.22-6.13h2.21Z" />
            <path style="fill: #f03840" d="M237.5 161.76v8.42h-2.05v-3.47h-3.19v3.47h-2.05v-8.42h2.05v3.3h3.19v-3.3zM241.03 161.76v8.42h-2.05v-8.42zM248.11 164.43c-.15-.28-.37-.49-.65-.64s-.62-.22-1-.22c-.66 0-1.2.22-1.6.65-.4.44-.6 1.02-.6 1.75 0 .78.21 1.38.63 1.82s1 .65 1.73.65c.5 0 .93-.13 1.28-.38.35-.26.6-.62.76-1.1h-2.6v-1.51h4.46v1.91a4.041 4.041 0 0 1-2.16 2.5c-.56.27-1.19.41-1.9.41-.83 0-1.57-.18-2.23-.55-.65-.36-1.16-.87-1.52-1.52s-.55-1.39-.55-2.22.18-1.57.55-2.23c.36-.65.87-1.16 1.52-1.52s1.39-.55 2.22-.55c1.01 0 1.86.24 2.55.73s1.15 1.16 1.37 2.03h-2.27ZM258.96 161.76v8.42h-2.05v-3.47h-3.19v3.47h-2.05v-8.42h2.05v3.3h3.19v-3.3z" />
            <circle style="fill:#fff"  cx="150" cy="150" r="5.06" />
        </svg>
        
    </div>`;
}
/**
 * This function generates the HTML template for a single insurance item.
 * This is the stacked variant with the new overrides
 * 
 * @param {string} insurance 
 * @param {number} index 
 * @param {boolean} mostPopular 
 * @param {string} vehicle_id 
 * @returns {string} template
 */
export const insuranceItemStacked = (insurance, index, mostPopular = undefined, defaultSelected = undefined, vehicle_id = undefined) => {

    let insuranceCostPerDay = parseFloat(insurance.fees);

    if (insurance.maximumprice === insurance.totalinsuranceamount) insuranceCostPerDay = parseFloat(insurance.totalinsuranceamount / insurance.numberofdays);

    insuranceCostPerDay = Math.round(insuranceCostPerDay);

    // Determine if the insurance item is recommended ( used to default to the first item || (!mostPopular && index === 0))
    let recommended = (mostPopular === insurance.id) ? 'recommended-for-you' : '';

    // Determine if the insurance item is the default selected
    let selected = (defaultSelected === insurance.id || index === 0 && defaultSelected === undefined) ? 'selected' : '';

    // Check for any overrides for this insurance
    let override = false;

    if (window.insurance_overrides && window.insurance_overrides.length > 0) {

        // Check to see if the override is for this insurance
        override = window.insurance_overrides.filter(override => {
            return parseInt(override.insurance_id) == parseInt(insurance.id)
        })[0];


        if (override && override.vehicle_id) {
            // If we have an override and a vehicle ID, we need to apply the override to the specific vehicle
            if (parseInt(override.associated_vehicle_id) !== parseInt(vehicle_id)) {
                override = false;
            }
        }

    }

    let title = formatInsuranceText(insurance.name);
    let features = /*html*/`
        <ul class>
            ${(insurance.feedescription1) ? `<li>${stripTags(insurance.feedescription1)}</li>` : ``}
            ${(insurance.feedescription2) ? `<li>${stripTags(insurance.feedescription2)}</li>` : ``}
            ${(insurance.feedescription3) ? `<li>${stripTags(insurance.feedescription3)}</li>` : ``}
        </ul>`;

    let information_link = '';
    let risk_level = undefined;


    //Apply the overrides if they exist
    if (override) {
        if (override.title) title = override.title;
        if (override.features) features = override.features;
        if (override.information_link) information_link = /*html*/`<p><a href="${override.information_link}" target="_blank">Learn more</a></p>`;
        if (override.risk_level) risk_level = override.risk_level;
    }

    return /*html*/`
    <div class="insurances__item ${selected} ${recommended}" data-id="${insurance.id}" data-index="${index}">
        <div class="insurances__intro">
            <div class="insurances__header">
                <h6>${title}</h6>
            </div>
            <div class="insurances__price">
                <h2><sup>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}</sup>${insuranceCostPerDay}<span>/per day</span></h2>
            </div>
            <div class="insurances__actions">
                <button data-id="${insurance.id}"class="[ js-select-insurance ] button button--small">Select</button>
            </div>
        </div>
        ${(risk_level) ? insuranceRiskMeter(risk_level) : ``}
        <div class="insurances__features">
            <p><b>What's included:</b></p>
            ${features}
            <div class="insurances__footer">
                ${information_link}
            </div>
        </div>
    </div>`;
};


/**
 * 
 * Addon item template for the booking page
 * 
 * @param {object} insurance 
 * @param {number} index 
 * @returns {string} html template
 */
export const addonItem = (addon, featured_accessory) => {

    //Get the correct icon for the specific addon
    let icon = '';
    switch (addon.id) {
        case 322:
        case 321:
            icon = '<img src="/_resources/themes/mercury/dist/images/svg/ferry.svg" loading="lazy">';
            break;
        case 319:
        case 318:
            icon = '<img src="/_resources/themes/mercury/dist/images/svg/gps.svg" loading="lazy">';
            break;
        case 83:
        case 87:
            icon = '<img src="/_resources/themes/mercury/dist/images/svg/chairs.svg" loading="lazy">';
            break;
        case 65:
            icon = '<img src="/_resources/themes/mercury/dist/images/svg/gas.svg" loading="lazy">';
            break;
        default:
            icon = '';
            break;
    }

    return /*html*/`
    <div class="cards__item__addons__item ${(featured_accessory === addon.id) ? `featured-accessory` : ``}" data-id="${addon.id}">
        <div class="cards__item__addons__item__icon">
            ${icon}
        </div>
        <div class="cards__item__addons__item__copy">
            <h6 class="cards__item__addons__item__copy__title">
                ${addon.name}
            </h6>
            <div class="cards__item__addons__item__copy__features">
                ${(addon.feedescription1) ? `<div class="cards__item__addons__item__copy__features__item">${addon.feedescription1}</div>` : ``}
                ${(addon.feedescription2) ? `<div class="cards__item__addons__item__copy__features__item">${addon.feedescription2}</div>` : ``}
                ${(addon.feedescription3) ? `<div class="cards__item__addons__item__copy__features__item">${addon.feedescription3}</div>` : ``}
            </div>
            <div class="cards__item__addons__item__copy__toggle [ js-toggle-features ]">
                View all features <svg viewBox="0 0 100 100"><path d="M90 50 40 0 30 10l40 40-40 40 10 10Z" fill="#333" class="arrow"/></svg>
            </div>
        </div>
        <div class="cards__item__addons__item__actions">
            <div class="cards__item__addons__item__actions__price">
                <b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${addon.fees}</b>
                ${(addon.type === 'Daily') ? `<span>PER DAY</span>` : ``}
                ${(addon.qtyapply) ? /*html*/`
                    <div class="cards__item__addons__item__actions__price__quantity [ js-addon-quantity-wrap ]">
                        <input value="1" type="text" class="cards__item__addons__item__actions__price__quantity__input [ js-addon-quantity ]">
                        <b class="cards__item__addons__item__actions__price__quantity__add [ js-add-quantity ]"><svg viewBox="0 0 100 100"><path d="M90 50 40 0 30 10l40 40-40 40 10 10Z" fill="#333" class="arrow"></path></svg></b>
                        <b class="cards__item__addons__item__actions__price__quantity__subtract [ js-subtract-quantity ]"><svg viewBox="0 0 100 100"><path d="M90 50 40 0 30 10l40 40-40 40 10 10Z" fill="#333" class="arrow"></path></svg></b>
                    </div>` : ``}
            </div>
            <div class="cards__item__addons__item__actions__add"><button data-id="${addon.id}" class="[ js-select-addon ] button button--small">Add</button></div>
        </div>
    </div>`;
};


/**
 * 
 * Booking summary item template for the booking page
 * 
 * @param {object} item 
 * @returns {string} html template
 */
export const summaryBooking = (item) => {
    return /*html*/`
    <div class="cards__item__list__item cards__item__list__item--cost">
        ${item.numberofdays} days @ ${window.defaults.currency_symbol}${item.discounteddailyrate} per day
        <b>${window.defaults.currency_symbol}${item.totalrateafterdiscount.toFixed(2)}</b>
    </div>
    ${(item.totalrateafterdiscount < item.totalratebeforediscount) ?/*html*/`
    <div class="cards__item__list__item cards__item__list__item--cost">
        ${window.defaults.currency_symbol}${item.avgrate} per day less ${item.discountrate}% discount
    </div>`: ``}`;
};


/**
 * 
 * Insurance summary item template for the booking page
 * 
 * @param {object} item 
 * @returns {string} html template
 */
export const summaryInsurance = (item) => {

    // Test if insurance is at the max and needs to be converted to a daily basis
    let insurancePerDay = (item.maximumprice === item.totalinsuranceamount) ? parseFloat(item.totalinsuranceamount / item.numberofdays).toFixed(0) : item.fees;

    return /*html*/`
    <div class="cards__item__list__item cards__item__list__item--cost">
        ${item.name}<br>
        ${item.numberofdays} days @ ${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${insurancePerDay} per day
        <b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${item.totalinsuranceamount.toFixed(2)}</b>
    </div>`;
};


/**
 * 
 * Booking summary item template for the booking page
 * 
 * @param {object} item 
 * @returns {string} html template
 */
export const summaryAddon = (item, quantity = 1) => {

    if (item.name === 'Remote location fee (reduced)' || item.name === 'Remote location fee' || item.name === 'Regional depot service fee') {
        return /* html */`
        <div class="cards__item__list__item cards__item__list__item--cost">
            ${item.name} ${(item.qty && item.qty > 1) ? `x ${item.qty}` : ''}
            <span class="tipped"><i>i</i><b>Some of our depots are operated out of other business premises. They charge us a fee for it, which is called a 'remote location' fee.</b></span>
            ${(item.totalfeeamount === 0 && item.id !== 387) ? '<b class="colour--green">FREE</b>' : `<b>${(window.pageType === 'agent') ? window.price_locale + item.totalfeeamount : window.defaults.currency_symbol + item.totalfeeamount}</b>`}
        </div>`;
    } else {
        return /*html*/`
        <div class="cards__item__list__item cards__item__list__item--cost" style="${(item.fees === 0) ? `order:999;` : ``}">
            ${item.name} ${(quantity > 1) ? `x ${quantity}` : ``}
            ${(item.fees === 0 && item.id !== 387) ? `<b class="colour--green">FREE</b>` : `<b>${(window.pageType === 'agent') ? window.price_locale : window.defaults.currency_symbol}${parseFloat(item.totalfeeamount * quantity).toFixed(2)}</b>`}
        </div>`;
    }

};


/**
* 
* Booking summary item template for the booking page in particular for free days if they have been unlocked
*
* @param {object} item 
* @returns {string} html template
*/
export const summaryFreeDays = (days, savings) => {
    return /*html*/`
    <div class="cards__item__list__item cards__item__list__item--cost">
        You've unlocked ${days} free day${(days === 1) ? `` : `s`}
       <b class="colour--green">-${window.defaults.currency_symbol}${savings.toFixed(2)}</b>
    </div>`;
};


/**
 * 
 * Booking summary total template for the booking page
 * 
 * @param {object} item 
 * @returns {string} html template
 */
export const summaryTotal = (title, amount, currency) => {
    return /*html*/`
    <div class="cards__item__list__item cards__item__list__item--cost" style="order:9999;">
        ${title}
        <b>${(currency) ? currency : ``}${window.defaults.currency_symbol}${amount.toFixed(2)}</b>
    </div>`;
};

/**
 * 
 * Booking summary savings template for the booking page
 * 
 * @param {string} title 
 * @param {string} amount 
 * @param {string} currency 
 * @returns {string} html template
 */
export const summarySavings = (title, amount, currency) => {
    return /*html*/`
    <div class="cards__item__list__item cards__item__list__item--savings" style="order:9998;">
        ${title}
        <b>${window.defaults.currency_symbol}${amount.toFixed(2)}</b>
    </div>`;
};


/**
 * 
 * Get the featured image of the selected vehicle
 * 
 * @param {object} image 
 * @param {number} index 
 * @returns {string} html template
 */
export const selectedVehicleGalleryImage = (image, index) => {
    return /*html*/`
    <div class="cars__item__gallery__slider__item" data-image-url="${image.original}" data-pos="${index}">
        <img class="cars__item__gallery__slider__item__image" src="${image.thumbnail}">
            ${(image.description) ? `<p class="cars__item__gallery__slider__item__title">${image.description}</p>` : ``}
    </div>`;
};


/**
 * 
 * The selected vehicle gallery images
 * 
 * @param {array} gallery_images 
 * @returns {string} html template
 */
export const selectedVehicleGallery = (gallery_images) => {
    return /*html*/`
    <div class="[ js-selected-car-slider ]">
        ${gallery_images.map((item, index) => selectedVehicleGalleryImage(item, index)).join('')}
    </div>`;
};


/**
 * 
 * Credit card template
 * 
 * @param {object} card 
 * @returns {string} html template
 */
export const card = (card) => {
    return /*html*/`
    <div class="card">
        <div class="card__shape-1"></div>
        <div class="card__shape-2"></div>
        <div class="card__name">Credit Card</div>
        <div class="card__numbers">0000 0000 0000 0000</div>
        <div class="card__chip">
            <svg width="100.0004" height="75.1834" viewBox="0 0 100.0004 75.1834" xmlns="http://www.w3.org/2000/svg"><path d="M90.2192 0H9.7812C4.3789 0 0 4.3789 0 9.7812v55.621c0 5.4023 4.3789 9.7812 9.7812 9.7812h80.438c5.4023 0 9.7812-4.3789 9.7812-9.7812V9.7812C100.0004 4.3789 95.6215 0 90.2192 0Zm-32.133 13.695 6.707 12.012-6.6953 11.25c-.19531.33594-.19531.75 0 1.0859l6.707 11.957-6.707 11.293c-.19531.33594-.19531.75 0 1.0859l5.9453 10.629-28.359.003906 6.2188-10.426c.19531-.33594.19531-.75 0-1.0859l-6.6953-12.012 6.6953-11.227c.19531-.33594.19531-.75 0-1.0898l-6.707-12.02 6.707-11.238c.19531-.33594.19531-.75 0-1.0898l-5.9258-10.652h28.34l-6.2188 10.438c-.19922.33203-.20312.74609-.011718 1.0859L58.0862 13.695Zm8.457 35-6.2617-11.184 6.4141-10.75h31.129v21.934H66.5432ZM33.4692 26.5l6.25 11.184-6.4141 10.75H2.1761V26.5h31.2931ZM9.7812 2.172h23.707l6.2266 11.141-6.5234 11-31.016.003906v-14.535c0-4.1992 3.4062-7.6094 7.6055-7.6094L9.7812 2.172Zm23.34 48.438c.027344.03125.0625.058593.097656.085937.070312.042969.14844.074219.22656.097656l6.2617 11.219-6.5234 11h-23.402c-4.1992 0-7.6055-3.4062-7.6055-7.6094V50.61H33.1212Zm57.098 22.402h-23.707l-6.2305-11.141 6.5234-11h31.02v14.531c0 2.0195-.80078 3.9531-2.2266 5.3789-1.4258 1.4297-3.3633 2.2305-5.3789 2.2305l-.0004.0006Zm-23.34-48.426c-.027344-.03125-.0625-.058593-.097656-.085937-.066406-.03125-.14062-.058594-.21484-.078125l-6.2852-11.238 6.5664-11.012h23.371c4.1992 0 7.6055 3.4102 7.6055 7.6094v14.805L66.8792 24.586Z" fill="#000" fill-rule="nonzero"/></svg>
        </div>
        <div class="card__added">Added: ${card.dateadded}</div>
    </div>
    `;
};


/**
 * 
 * Get a signature template for the portal
 * 
 * @param {object} signature 
 * @param {string} url 
 * @returns {string} html template
 */
export function signature(signature, url) {
    const agreementLink = url
        ? /*html*/`<a href="${url}" class="[ js-rental-agreement-modal ]" target="_blank" style="text-decoration: underline !important;">Rental Agreement</a>`
        : 'Rental Agreement';

    return /*html*/`
    <div class="signature [ js-signature ]" data-customerid="${signature.customerid}" data-signaturetemplateid="${signature.signaturetemplateid}">
        <h6 class="signature__heading">Rental Agreement</h6>
        <div class="signature__canvas"><canvas></canvas></div>
        <div class="signature__actions">
            <p class="smallest">I ${signature.customerfirstname} ${signature.customerlastname}, have read and consent to the ${agreementLink}</p>
            <button class="button button--blue signature__canvas__clear [ js-clear-signature ]">Clear<span class="buttonLoader"></span></button>
            <button class="button signature__canvas__save [ js-save-signature ]">Save<span class="buttonLoader"></span></button>
        </div>
    </div>`
}


/**
 * 
 * Country select dropdown options
 * 
 * @param {array} countries 
 * @returns {string} html template
 */
export function countrySelect(countries) {
    return /*html*/`<option value="">Please select a country from the list</option>${countries.map(country => `<option value="${country.id}">${country.country}</option>`).join(``)}`
}


/**
 *
 * Wraps every occurrence of each word in `query` with <mark> tags
 *
 * @param {string} text
 * @param {string} query
 * @returns {string} html safe-ish highlighted text
 */
function highlightMatch(text, query) {
    let words = (query || '').trim().split(/\s+/).filter(Boolean).map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    if (!words.length) return text;
    return text.replace(new RegExp(`(${words.join('|')})`, 'gi'), '<mark>$1</mark>');
}


/**
 *
 * Address autocomplete suggestions list
 *
 * @param {array} results
 * @param {string} query the text the customer typed, used to highlight matches
 * @returns {string} html template
 */
export function addressSuggestions(results, query) {
    return /*html*/`${results.map(result => `<li class="address-autocomplete__item" data-place-id="${result.place_id}">${highlightMatch(result.display_name, query)}</li>`).join(``)}`
}


/**
 * 
 * Empty drivers warning copy template
 * 
 * @returns {string} html template
 */
export function no_extra_drivers() {
    return /*html*/`<h6 class="text-center">You don't have any extra drivers set, click below to add one to your journey.</h6>`
}


/**
 * 
 * Extra driver template
 * 
 * @param {object} extra_driver 
 * @returns {string} html template
 */
export function extra_driver(extra_driver) {
    return /*html*/`
    <div class="steps__wrap__item__drivers__item">  
        <div class="steps__wrap__item__drivers__item__icon">  
            <div class="steps__wrap__item__drivers__item__icon__avatar">  
                <img src="/_resources/themes/mercury/dist/images/svg/avatar.svg" alt="Avatar for ${extra_driver.firstname} ${extra_driver.lastname}">
            </div>
        </div>
        <div class="steps__wrap__item__drivers__item__details">  
            <h6><b>${extra_driver.firstname} ${extra_driver.lastname}</b></h6>
            <p>${extra_driver.email}<br>${extra_driver.dateofbirth}</p>
        </div>
        <div class="steps__wrap__item__drivers__item__actions">  
            <button class="button button--tiny button--orange [ js-remove-extra-driver ]" data-id="${extra_driver.customerid}">Remove<span class="buttonLoader"></span></button>
            <button class="button button--tiny button--blue [ js-edit-extra-driver ]" data-id="${extra_driver.customerid}">Edit</button>
        </div>
    </div>
    `
}


/**
 * 
 * Uploaded document template
 * 
 * @param {*} document 
 * @returns {string} html template
 */
export function uploaded_document(document) {
    return /*html*/`
    <div class="uploads__item uploads__item--uploaded">
        <div class="uploads__item__thumbnail" data-customer-id="${document.customerid}"  data-upload-id="${document.documentlinkid}">
            <div class="uploads__item__thumbnail__id">
                <svg width="100" height="70" viewBox="0 0 100 70" xmlns="http://www.w3.org/2000/svg"><path d="M90.316 44.91H49.109v-1.563h41.207v1.563zM69.41 29.941H49.109v1.563H69.41V29.94zM42.668 43.609v15.023l-33.707.004V43.609c0-6.41 6.066-12.031 12.984-12.031l1.125-.082c-4.332-1.207-7.52-5.192-7.52-9.91 0-5.672 4.606-10.29 10.262-10.29 5.66 0 10.262 4.614 10.262 10.29 0 4.832-3.343 8.894-7.831 9.992h1.437c6.922 0 12.988 5.625 12.988 12.03v.001zM25.816 30.312c4.8 0 8.703-3.914 8.703-8.727 0-4.812-3.906-8.726-8.703-8.726-4.8 0-8.703 3.914-8.703 8.726 0 4.813 3.902 8.727 8.703 8.727zm15.293 13.297c0-5.469-5.129-10.27-11.066-10.461h-8.46c-5.934.191-11.063 4.992-11.063 10.461v13.465h5.785V42.812h1.559v14.262H33.77V42.812h1.558v14.262h5.786V43.609h-.005zm8 14.707h41.207v-1.563H49.109v1.563zM100 8.011v53.98c0 4.012-3.258 7.277-7.258 7.277l-85.484-.004C3.258 69.268 0 66.003 0 61.987V8.01C0 3.998 3.258.733 7.258.733h85.48C96.742.733 100 3.994 100 8.01v.001zm-1.559 0c0-3.152-2.558-5.715-5.699-5.715H7.258c-3.144 0-5.699 2.563-5.699 5.715v53.98c0 3.152 2.559 5.715 5.7 5.715h85.48c3.144 0 5.698-2.563 5.698-5.715l.004-53.98z" fill="#000" fill-rule="nonzero"></path></svg>
            </div>
            <div class="uploads__item__thumbnail__loader"></div>
            <p class="uploads__item__thumbnail__context">Driver's license  for ${document.customerfirstname}</p>
        </div>
        <p class="[ js-delete-upload ] button button--orange button--full-width button--smaller" data-upload-id="${document.documentlinkid}">Remove Upload</p>
    </div>
    `
}


/**
 * 
 * Upload document template
 * 
 * @param {object} document 
 * @returns {string} html template
 */
export function upload_document(document) {

    let options = {};
    let webcam_button = ``;

    navigator.getMedia = (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);

    if (window.innerWidth < 768) options = { advanced: [{ facingMode: "environment" }] };

    if (navigator.getMedia) {
        navigator.getMedia({ video: options }, () => {
            webcam_button += /*html*/` <p class="[ js-webcam ]">Or Use Webcam</p>`;
        }, () => {
            webcam_button += ``;
        });
    }

    webcam_button += /*html*/`<p class="[ js-webcam ] button button--full-width button--smaller useWebcam" data-customer-id="${document.customerid}"><svg width="17" height="22" viewBox="0 0 17 22" xmlns="http://www.w3.org/2000/svg"><g fill="#fff" fill-rule="nonzero"><path d="M7.722 17.174c-4.161 0-7.547-3.469-7.547-7.732S3.56 1.71 7.722 1.71s7.548 3.469 7.548 7.732c0 4.264-3.387 7.732-7.548 7.732zm0-14.769C3.934 2.405.854 5.562.854 9.442c0 3.881 3.08 7.036 6.868 7.036 3.787 0 6.87-3.155 6.87-7.036 0-3.88-3.083-7.037-6.87-7.037z"/><path d="M7.723 21.775c-2.315 0-4.658-.644-4.658-1.879 0-.686.732-1.246 2.066-1.582.262-.618.264-1.181.008-1.717l-.354-.744.767.261a6.68 6.68 0 0 0 4.342 0l.767-.261-.355.744c-.256.537-.253 1.1.009 1.716 1.335.337 2.066.896 2.066 1.583 0 1.235-2.344 1.88-4.658 1.88zM5.967 16.96c.105.579.007 1.184-.294 1.81l-.071.148-.158.036c-1.247.289-1.7.722-1.7.944 0 .483 1.55 1.184 3.98 1.184 2.427 0 3.977-.701 3.977-1.184 0-.223-.452-.656-1.7-.944l-.157-.036-.072-.149c-.301-.624-.4-1.229-.294-1.808a7.29 7.29 0 0 1-3.511 0zM7.722 13.141c-1.8 0-3.267-1.502-3.267-3.347 0-1.846 1.467-3.347 3.267-3.347 1.801 0 3.267 1.502 3.267 3.347s-1.466 3.347-3.267 3.347zm0-5.998c-1.427 0-2.588 1.188-2.588 2.651 0 1.462 1.16 2.652 2.588 2.652 1.428 0 2.588-1.19 2.588-2.652 0-1.463-1.161-2.651-2.588-2.651z"/><path d="M7.722 11.634c-.99 0-1.796-.825-1.796-1.84 0-1.015.806-1.84 1.796-1.84.991 0 1.797.826 1.797 1.84 0 1.015-.807 1.84-1.797 1.84zm0-2.985c-.617 0-1.117.513-1.117 1.144 0 .632.501 1.145 1.117 1.145.617 0 1.118-.513 1.118-1.145 0-.63-.502-1.144-1.118-1.144z"/><path d="M7.722 10.756a.951.951 0 0 1-.938-.962.95.95 0 0 1 .938-.961.95.95 0 0 1 .939.961c0 .53-.421.962-.939.962zm0-1.228c-.143 0-.26.119-.26.265 0 .147.117.266.26.266.144 0 .26-.119.26-.266a.263.263 0 0 0-.26-.265zM5.67 6.157a.946.946 0 0 1-.932-.956c0-.527.418-.956.933-.956.514 0 .933.429.933.956a.946.946 0 0 1-.933.956zm0-1.217a.258.258 0 0 0-.253.26c0 .144.114.26.254.26s.254-.117.254-.26a.257.257 0 0 0-.254-.26zM16.147 9.8c-.1-5.246-3.149-7.496-5.689-8.459l.236-.652c2.738 1.039 6.026 3.46 6.131 9.099l-.678.013zM9.139.933C8.293.729 7.709.695 7.704.693L7.74 0c.025.002.645.037 1.555.257l-.156.676z"/></g></svg>Or Use Webcam</p>`;
    webcam_button += /*html*/`<p class="[ js-webcam ] button button--full-width button--smaller usePhone" data-customer-id="${document.customerid}"><svg width="16" height="20" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg"><g fill="#fff" fill-rule="nonzero"><path d="M5.86 18h-.598a.027.027 0 0 1-.027-.027v-.612c0-.016.013-.027.027-.027h.598c.014 0 .026.011.026.027v.612A.027.027 0 0 1 5.86 18zm0 .666c.374 0 .677-.31.677-.693v-.612a.686.686 0 0 0-.677-.695h-.598a.686.686 0 0 0-.677.695v.612c0 .383.304.693.677.693h.598zM.357 2.666H2.96a.33.33 0 0 0 .324-.332A.33.33 0 0 0 2.96 2H.357a.33.33 0 0 0-.324.334.33.33 0 0 0 .324.332z"/><path d="M.033 15.666v3.014c0 .729.576 1.32 1.288 1.32H9.8c.712 0 1.288-.591 1.288-1.32v-3.014H.033zm10.406.668v2.346c0 .36-.286.653-.638.653h-8.48a.646.646 0 0 1-.638-.653v-2.346h9.756zM12.706 4.586a.327.327 0 0 0-.316-.252H9.138a.328.328 0 0 0-.316.252l-.263 1.08H5.886A.33.33 0 0 0 5.561 6v6.666a.33.33 0 0 0 .325.334h9.757a.33.33 0 0 0 .324-.334V6a.33.33 0 0 0-.324-.334H12.97l-.264-1.08zm2.611 7.748H6.211v-6h2.602a.328.328 0 0 0 .316-.254L9.392 5h2.744l.264 1.08a.327.327 0 0 0 .316.254h2.601v6z"/><path d="M12.065 9c0 .736-.583 1.334-1.3 1.334-.72 0-1.302-.598-1.302-1.334 0-.736.583-1.334 1.301-1.334s1.3.598 1.3 1.334zm.65 0c0-1.105-.874-2-1.95-2-1.078 0-1.952.895-1.952 2s.874 2 1.951 2 1.952-.895 1.952-2z"/><path d="M6.211 6.334h2.602a.328.328 0 0 0 .316-.254L9.392 5h1.373a.33.33 0 0 0 .324-.334V1.525C11.09.683 10.424 0 9.602 0H1.52C.698 0 .033.683.033 1.525V18.68c0 .729.576 1.32 1.288 1.32H9.8c.712 0 1.288-.591 1.288-1.32v-6.014a.33.33 0 0 0-.324-.332H6.21v-6zM10.44 18.68c0 .36-.286.654-.638.654h-8.48a.646.646 0 0 1-.638-.654V1.525c0-.474.375-.859.837-.859h8.082c.462 0 .837.385.837.859v2.809H9.138a.328.328 0 0 0-.316.252l-.263 1.08H5.886A.33.33 0 0 0 5.561 6v6.666a.33.33 0 0 0 .325.334h4.553v5.68z"/></g></svg>Use Camera</p>`;

    return /*html*/`
    <div class="uploads__item uploads__item--upload">
        <div class="uploads__item__thumbnail [ js-upload-empty ]" data-customer-id="${document.customerid}">
            <div class="uploads__item__thumbnail__cloud">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60"><g fill="#DF542F"><path d="M38.845 39.69a.976.976 0 0 0 .691-1.667l-8.797-8.798a.976.976 0 0 0-1.38 0l-8.795 8.798a.976.976 0 0 0 1.38 1.38l7.127-7.129v23.051c0 .542.437.978.979.978a.977.977 0 0 0 .978-.978v-23.05l7.128 7.127a.95.95 0 0 0 .689.288z"></path><path d="M48.75 17.093c-.542-7.18-6.618-12.9-13.895-12.9-5.813 0-11.036 3.677-13.058 9.059a9.752 9.752 0 0 0-2.798-.41c-5.103 0-9.29 3.99-9.603 9.017A11.532 11.532 0 0 0 .729 33.033c0 6.366 5.177 11.543 11.544 11.543h11.909a.977.977 0 0 0 .978-.979.977.977 0 0 0-.978-.978l-11.903.003c-5.288 0-9.592-4.304-9.592-9.592a9.577 9.577 0 0 1 7.855-9.425l.823-.149-.032-.99c0-4.228 3.44-7.67 7.67-7.67 1.046 0 2.062.208 3.02.618l1.017.433.31-1.06c1.48-5.09 6.209-8.64 11.506-8.64 6.48 0 11.856 5.276 11.98 11.76l.014.797.785.146a11.985 11.985 0 0 1 9.782 11.777c0 6.12-4.596 11.292-10.675 11.962l-.363.032H35.917a.977.977 0 0 0-.979.979c0 .542.437.978.979.978h10.951l.78-.085c6.84-1.154 11.628-7.04 11.628-13.863-.006-6.448-4.327-12.02-10.524-13.538h-.002z"></path></g></svg>
            </div>
            <div class="uploads__item__thumbnail__loader"></div>
            <p class="uploads__item__thumbnail__context">Upload driver's license for ${document.customerfirstname}</p>
        </div>
        <div class="uploads__item__actions">
            ${webcam_button}
        </div>
    </div>
    `
}


/**
 * 
 * SWAL Booking title
 * 
 * @returns {string} html template
 */
export const rental_agreement_modal = (URL) => {
    return /*html*/`
    <div class="rental">
    <div class="rental__close [ js-close-rental-agreement-tingle ]"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="35.976" viewBox="0 0 36 35.976"><path fill="#000" fill-rule="evenodd" d="M8.18 0 0 8.18.82 9l9 8.988L0 27.807l.82.807 7.36 7.362 9.82-9.82 9.82 9.82 7.36-7.362.82-.807-9.82-9.82 9-8.987.82-.82L27.82 0 18 9.82 8.18 0Zm0 3.265 9.82 9.82 9.82-9.82 4.903 4.904-9.82 9.819.82.807 9 9-4.904 4.916L18 22.89l-9.82 9.82-4.903-4.916 9-9 .82-.807-9.82-9.82 4.904-4.903Z"/></svg></div>
    <div class="rental__viewport">
       <iframe src="${URL}" frameborder="0"></iframe>
    </div>
    </div>`;
};

/**
 * 
 * SWAL Booking title
 * 
 * @returns {string} html template
 */
export const webcam_modal = (customer_id) => {
    return /*html*/`
    <div class="webcam">
    <div class="webcam__close [ js-close-tingle ]"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="35.976" viewBox="0 0 36 35.976"><path fill="#000" fill-rule="evenodd" d="M8.18 0 0 8.18.82 9l9 8.988L0 27.807l.82.807 7.36 7.362 9.82-9.82 9.82 9.82 7.36-7.362.82-.807-9.82-9.82 9-8.987.82-.82L27.82 0 18 9.82 8.18 0Zm0 3.265 9.82 9.82 9.82-9.82 4.903 4.904-9.82 9.819.82.807 9 9-4.904 4.916L18 22.89l-9.82 9.82-4.903-4.916 9-9 .82-.807-9.82-9.82 4.904-4.903Z"/></svg></div>
    <div class="webcam__viewport">
        <video id="cam" autoplay muted playsinline>Not available</video>
        <canvas id="canvas" style="display:none"></canvas>  
        <img id="photo" alt="The screen capture will appear in this box." style="display:none;">  
    </div>
    <div class="webcam__actions">
        <button class="button button--blue [ js-switch-camera ]">Switch Camera</button>
        <button class="button button--green [ js-take-photo ]">Take Photo</button>
        <button class="button button--orange [ js-delete-photo ]" style="display:none;">Try Again</button>
        <button class="button button--green [ js-use-photo ]" style="display:none;" data-customer-id="${customer_id}">Use Photo</button>
    </div>
    </div>`;
};


/**
 * 
 * Swal modal to update a bookings' times
 * 
 * @param {string} pick_up_time 
 * @param {string} drop_off_time 
 * @returns {string} html template
 */
export const updated_booking_modal = (pick_up_time, drop_off_time) => {

    let contact_link = 'https://spaceshipsrentals.co.nz/about/contact-us/';
    if (window.currency_name === 'AUD') contact_link = 'https://spaceshipsrentals.com.au/about/contact-us/';

    return /*html*/`
    <p>Update your travel times below if they are available to you.</p>
    <p>If you would like to change your pick-up/drop-off time to after-hours, you'll need to <a href="${contact_link}" target="_blank">contact us to request it.</a></p>
    <div class="text-left field text half">
        <label for="mobile" class="left">Pick up time</label>
        <select name="updated-pickup-time" id="updated-pickup-time" required="required" class="[ js-updated-pickup-time ]">
            ${(pick_up_time < '09:00') ? `<option value="${pick_up_time}" selected>Early after hours</option>` : ``}
            <option value="09:00" ${(pick_up_time === '09:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '09:00') ? `disabled` : ``}>09:00</option>
            <option value="10:00" ${(pick_up_time === '10:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '10:00') ? `disabled` : ``}>10:00</option>
            <option value="11:00" ${(pick_up_time === '11:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '11:00') ? `disabled` : ``}>11:00</option>
            <option value="12:00" ${(pick_up_time === '12:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '12:00') ? `disabled` : ``}>12:00</option>
            <option value="13:00" ${(pick_up_time === '13:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '13:00') ? `disabled` : ``}>13:00</option>
            <option value="14:00" ${(pick_up_time === '14:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '14:00') ? `disabled` : ``}>14:00</option>
            <option value="15:00" ${(pick_up_time === '15:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '15:00') ? `disabled` : ``}>15:00</option>
            <option value="16:00" ${(pick_up_time === '16:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && pick_up_time > '16:00') ? `disabled` : ``}>16:00</option>
            ${(pick_up_time > '16:00') ? `<option value="${pick_up_time}" selected>After hours</option>` : ``}
        </select>
    </div>
    <div class="text-left field text half half--last">
        <label for="mobile" class="left">Drop off time</label>
        <select name="updated-dropoff-time" id="updated-dropoff-time" required="required" class="[ js-updated-dropoff-time ]">
            ${(drop_off_time < '09:00') ? `<option value="${drop_off_time}" selected>Early after hours</option>` : ``}
            <option value="09:00" ${(drop_off_time === '09:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '09:00') ? `disabled` : ``}>09:00</option>
            <option value="10:00" ${(drop_off_time === '10:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '10:00') ? `disabled` : ``}>10:00</option>
            <option value="11:00" ${(drop_off_time === '11:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '11:00') ? `disabled` : ``}>11:00</option>
            <option value="12:00" ${(drop_off_time === '12:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '12:00') ? `disabled` : ``}>12:00</option>
            <option value="13:00" ${(drop_off_time === '13:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '13:00') ? `disabled` : ``}>13:00</option>
            <option value="14:00" ${(drop_off_time === '14:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '14:00') ? `disabled` : ``}>14:00</option>
            <option value="15:00" ${(drop_off_time === '15:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '15:00') ? `disabled` : ``}>15:00</option>
            <option value="16:00" ${(drop_off_time === '16:00') ? `selected` : ``} ${(window.currency_name === 'AUD' && drop_off_time < '16:00') ? `disabled` : ``}>16:00</option>
            ${(drop_off_time > '16:00') ? `<option value="${drop_off_time}" selected>After hours</option>` : ``}
        </select>
    </div>`
};

/**
 * 
 * Status bar flag template
 * 
 * @param {string} currency_name 
 * @returns {string} html template
 */
export const currency_flag = (currency_name) => {
    return /*html*/`
    <img src="/_resources/themes/mercury/dist/images/svg/${currency_name}-flag.svg" width="45" height="22" loading="lazy">
    <p><b>${currency_name}</b></p>`
};
